import React from "react"
import { TextArea, Input, FileInput, FormField, Error } from "@bw/forms"
import axios from "axios"
import { Field } from "formik"
import * as yup from "yup"

export const displayField = (field, formik) => {
  switch (field.type) {
    case "textarea":
      return (
        <FormField
          name={field.handle}
          title={field.display}
          help={field.instructions}
          helpPosition={field.instructions_position}
        >
          <Field
            placeholder={field.placeholder}
            name={field.handle}
            component={TextArea}
          />
        </FormField>
      )

    case "checkboxes":
      return (
        <FormField
          name={field.handle}
          title={field.display}
          help={field.instructions}
          helpPosition={field.instructions_position}
        >
          {Object.values(field.options).map((label, i) => {
            const value = Object.keys(field.options)[i]
            return (
              <label
                style={{ display: "flex", gap: "5px", alignItems: "center" }}
              >
                <Field type="checkbox" name={field.handle} value={value} />
                {label}
              </label>
            )
          })}
        </FormField>
      )

    case "radio":
      return (
        <FormField
          name={field.handle}
          title={field.display}
          help={field.instructions}
          helpPosition={field.instructions_position}
        >
          {Object.values(field.options).map((label, i) => {
            const key = Object.keys(field.options)[i]
            return (
              <label
                key={key}
                style={{ display: "flex", gap: "5px", alignItems: "center" }}
              >
                <Field type="radio" name={field.handle} value={key} />
                {label}
              </label>
            )
          })}
        </FormField>
      )

    case "select":
      return (
        <FormField
          name={field.handle}
          title={field.display}
          help={field.instructions}
          helpPosition={field.instructions_position}
        >
          <Field as="select" name={field.handle}>
            {Object.values(field.options).map((option, i) => {
              const key = Object.keys(field.options)[i]
              return <option value={key}>{option}</option>
            })}
          </Field>
        </FormField>
      )

    case "assets":
      return (
        <FormField
          name={field.handle}
          title={field.display}
          help={field.instructions}
          helpPosition={field.instructions_position}
        >
          <Field
            name="file"
            onChange={event => {
              formik.setFieldValue(field.handle, [...event.currentTarget.files])
            }}
            component={FileInput}
          />
        </FormField>
      )

    case "text":
    case "number":
    case "integer":
    default:
      return (
        <FormField
          name={field.handle}
          title={field.display}
          help={field.instructions}
          helpPosition={field.instructions_position}
        >
          <Field
            type={field.input_type}
            placeholder={field.placeholder}
            name={field.handle}
            component={Input}
          />
        </FormField>
      )
  }
}

export const getFormFields = handle => {
  return axios({
    method: "GET",
    url: `/api/forms/${handle}`,
  }).then(response => {
    return response.data.data.fields
  })
}

/**
 * post form data
 */
export const postFormFields = (handle, values) => {
  const dataToSend = new FormData()
  dataToSend.append("_method", "POST")
  Object.entries(values).forEach(([key, value]) => {
    if (typeof value === "object" && value.length > 0) {
      // these are files
      value.forEach(file => {
        dataToSend.append(`${key}[]`, file)
      })
    } else {
      dataToSend.append(key, value)
    }
  })

  return axios({
    method: "POST",
    url: `/!/forms/${handle}`,
    data: dataToSend,
    headers: {
      "Content-Type": "multipart/form-data",
      "X-Requested-With": "XMLHttpRequest",
    },
  }).then(response => {
    if (response.status !== 200) {
      throw new Error("Invalid server response")
    }
    return response
  })
}

export const getInitialValues = fields => {
  return Object.values(fields).reduce((acc, field) => {
    switch (field.type) {
      case "checkboxes":
        acc[field.options] = []
        break

      case "text":
      case "textarea":
      case "select":
      case "radio":
      default:
        acc[field.handle] = ""
        break
    }
    return acc
  }, {})
}

const fieldType = type => {
  switch (type) {
    case "text":
    case "textarea":
    case "radio":
    case "select":
      return "string"

    case "number":
    case "integer":
      return "number"

    case "email":
      return "email"

    case "checkboxes":
      return "array"

    case "assets":
    default:
      return "mixed"
  }
}

export const fieldsSchema = (fields, t) => {
  return Object.values(fields).reduce((acc, field) => {
    const isArrayType =
      field.type === ("checkboxes" || "radio" || "select") ? yup.string() : ""

    if (field.validate && field.validate.includes("required")) {
      acc[field.handle] = yup[fieldType(fields.type)](isArrayType).required(
        t("form.required")
      )
    } else {
      acc[field.handle] = yup[fieldType(fields.type)](isArrayType).nullable()
    }
    return acc
  }, {})
}
